import React from "react";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import { legalDocument } from "./routes/legal-document";

export const publicRoutes = [
	{
		key: "login",
		path: `${AUTH_PREFIX_PATH}/login`,
		component: React.lazy(() => import("views/auth-views/authentication/login")),
	},
	{
		key: "register",
		path: `${AUTH_PREFIX_PATH}/register`,
		component: React.lazy(() => import("views/auth-views/authentication/register")),
	},
	{
		key: "forgot-password",
		path: `${AUTH_PREFIX_PATH}/forgot-password`,
		component: React.lazy(() => import("views/auth-views/authentication/forgot-password")),
	},
];

export const protectedRoutes = [
	{
		key: "dashboard",
		path: `${APP_PREFIX_PATH}`,
		component: React.lazy(() => import("views/app-views")),
	},
	{
		key: "users",
		path: `${APP_PREFIX_PATH}/users`,
		component: React.lazy(() => import("views/app-views/users")),
	},
	{
		key: "experts",
		path: `${APP_PREFIX_PATH}/experts`,
		component: React.lazy(() => import("views/app-views/experts")),
	},
	{
		key: "structures",
		path: `${APP_PREFIX_PATH}/structures`,
		component: React.lazy(() => import("views/app-views/structures")),
	},
	{
		key: "persons",
		path: `${APP_PREFIX_PATH}/persons`,
		component: React.lazy(() => import("views/app-views/persons")),
	},
	{
		key: "procedures",
		path: `${APP_PREFIX_PATH}/procedures`,
		component: React.lazy(() => import("views/app-views/procedures")),
	},
	{
		key: "attachments",
		path: `${APP_PREFIX_PATH}/attachments`,
		component: React.lazy(() => import("views/app-views/attachments")),
	},
	{
		key: "procedure",
		path: `${APP_PREFIX_PATH}/procedures/:procedureID`,
		component: React.lazy(() => import("views/app-views/procedures/show")),
	},
	/*	{
		key: "element-categories",
		path: `${APP_PREFIX_PATH}/element-categories`,
		component: React.lazy(() => import("views/app-views/element-categories")),
	},*/
	{
		key: "element-category",
		path: `${APP_PREFIX_PATH}/element-category/:elementID`,
		component: React.lazy(() => import("views/app-views/element-categories/show")),
	},
	{
		key: "sections",
		path: `${APP_PREFIX_PATH}/sections`,
		component: React.lazy(() => import("views/app-views/sections")),
	},
	{
		key: "sections",
		path: `${APP_PREFIX_PATH}/sections/:sectionID`,
		component: React.lazy(() => import("views/app-views/sections/show")),
	},
	{
		key: "tutorials",
		path: `${APP_PREFIX_PATH}/tutorials`,
		component: React.lazy(() => import("views/app-views/tutorials")),
	},
	{
		key: "banners",
		path: `${APP_PREFIX_PATH}/banners`,
		component: React.lazy(() => import("views/app-views/banners")),
	},
	{
		key: "useful_links",
		path: `${APP_PREFIX_PATH}/useful_links`,
		component: React.lazy(() => import("views/app-views/useful_links")),
	},
	{
		key: "entreprise_attributs",
		path: `${APP_PREFIX_PATH}/entreprise_attributs`,
		component: React.lazy(() => import("views/app-views/entreprise_attributs")),
	},
	{
		key: "forme_juridiques",
		path: `${APP_PREFIX_PATH}/forme_juridiques`,
		component: React.lazy(() => import("views/app-views/forme_juridiques")),
	},
	{
		key: "download_requests",
		path: `${APP_PREFIX_PATH}/download_requests`,
		component: React.lazy(() => import("views/app-views/download_requests")),
	},
	{
		key: "domains",
		path: `${APP_PREFIX_PATH}/domains`,
		component: React.lazy(() => import("views/app-views/domains")),
	},
	{
		key: "sliders",
		path: `${APP_PREFIX_PATH}/sliders`,
		component: React.lazy(() => import("views/app-views/sliders")),
	},
	{
		key: "partners",
		path: `${APP_PREFIX_PATH}/partners`,
		component: React.lazy(() => import("views/app-views/partners")),
	},
	{
		key: "faq-sections",
		path: `${APP_PREFIX_PATH}/faqs`,
		component: React.lazy(() => import("views/app-views/faq-sections")),
	},
	{
		key: "faq",
		path: `${APP_PREFIX_PATH}/faqs/:id`,
		component: React.lazy(() => import("views/app-views/faq-sections/show")),
	},
	{
		key: "offers",
		path: `${APP_PREFIX_PATH}/offers`,
		component: React.lazy(() => import("views/app-views/offers")),
	},
	{
		key: "offer",
		path: `${APP_PREFIX_PATH}/offers/:offerID`,
		component: React.lazy(() => import("views/app-views/offers/show")),
	},
	{
		key: "testimonials",
		path: `${APP_PREFIX_PATH}/testimonials`,
		component: React.lazy(() => import("views/app-views/testimonials")),
	},
	{
		key: "contents",
		path: `${APP_PREFIX_PATH}/contents`,
		component: React.lazy(() => import("views/app-views/contents")),
	},
	{
		key: "contents_create",
		path: `${APP_PREFIX_PATH}/contents/create`,
		component: React.lazy(() => import("views/app-views/contents/add")),
	},
	{
		key: "contents_detail",
		path: `${APP_PREFIX_PATH}/contents/:id`,
		component: React.lazy(() => import("views/app-views/contents/show")),
	},
	{
		key: "contents_edit",
		path: `${APP_PREFIX_PATH}/contents/:id/edit`,
		component: React.lazy(() => import("views/app-views/contents/edit")),
	},
	{
		key: "tickets",
		path: `${APP_PREFIX_PATH}/tickets/*`,
		component: React.lazy(() => import("views/app-views/tickets")),
	},
	{
		key: "newsletter",
		path: `${APP_PREFIX_PATH}/newsletter`,
		component: React.lazy(() => import("views/app-views/newsletter")),
	},
	{
		key: "articles",
		path: `${APP_PREFIX_PATH}/articles`,
		component: React.lazy(() => import("views/app-views/articles")),
	},
	{
		key: "roles",
		path: `${APP_PREFIX_PATH}/roles`,
		component: React.lazy(() => import("views/app-views/roles")),
	},
	{
		key: "roles_add",
		path: `${APP_PREFIX_PATH}/roles/add`,
		component: React.lazy(() => import("views/app-views/roles/add")),
	},
	{
		key: "roles_edit",
		path: `${APP_PREFIX_PATH}/roles/:id/edit`,
		component: React.lazy(() => import("views/app-views/roles/edit")),
	},
	{
		key: "settings",
		path: `${APP_PREFIX_PATH}/settings`,
		component: React.lazy(() => import("views/app-views/settings")),
	},
	...legalDocument,
];
